import React from 'react';
import propTypes from 'prop-types';
import { Routes, Route, useLocation } from 'react-router-dom';
import { LocationsListPage } from './LocationsListPage';
import { LocationsEditPageWrapper } from './LocationsEditPageWrapper';

export function LocationsPage({ isExpanded }) {
  const location = useLocation();
  
  return (
    <Routes location={location}>
      <Route
        path="/"
        element={<LocationsListPage isExpanded={isExpanded} />}
      />
      <Route
        path="add"
        element={<LocationsEditPageWrapper isExpanded={isExpanded} />}
      />
      <Route
        path="edit/:id"
        element={<LocationsEditPageWrapper isExpanded={isExpanded} />}
      />
    </Routes>
  );
}

LocationsPage.propTypes = {
  isExpanded: propTypes.bool.isRequired,
};
